import { Entities } from "@/types/permissions"
import { TRoutes } from "@/types/routes"
import { ManagementMenuRoutes, NavigationMenuRoutes } from "toptaal-shared"

export const navigationItems: NavigationMenuRoutes<TRoutes>[] = [
  { label: "Beheer", path: "/beheer" },
  // { label: "Dashboard", path: "/dashboard" }, // Temporarily hide dashboard
  { label: "Correspondentie", path: "/correspondentie" },
]

export const managementItems: ManagementMenuRoutes<TRoutes, Entities>[] = [
  { label: "Cursisten", path: "/beheer/cursisten", entity: "students" },
  {
    label: "Aanmeldingen",
    path: "/beheer/aanmeldingen",
    entity: "studentRegistrations",
  },
  // Hide this section for now since it's not implemented yet
  // {
  //   label: "Gebruikers",
  //   path: "/beheer/gebruikers",
  //   entity: "employees",
  // },
  {
    label: "Groepen",
    path: "/beheer/groepen",
    entity: "groups",
  },
  {
    label: "Medewerkers",
    path: "/beheer/medewerkers",
    entity: "contacts",
  },
  {
    label: "Contracten",
    path: "/beheer/contracten",
    entity: "projects",
  },
]
